module.exports = __webpack_public_path__ + "img/delete-left.57514363.svg";